<template v-slot:item.action>
  <div>
    <v-data-table
      v-model="itemsSelecionados"
      class="font-resp-table table-full-screen mx-1"
      height="calc(100vh - 270px)"
      :fixed-header="true"
      :headers="headers"
      :items="desserts"
      :items-per-page="-1"
      item-key="filial"
      show-select
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Lista de Mapeamento de Filial X CD
          </v-toolbar-title>

          <div id="remover" v-show="itemsSelecionados.length > 0">
            <v-btn
              color="red"
              @click="deleteItems(itemsSelecionados)"
              small dark
              class="ml-7 mt-1"
            >
              <v-icon small left>mdi-delete</v-icon>
              <span>Remover</span>
              <span class="qtde-top-button-small">{{itemsSelecionados.length}}</span>
            </v-btn>
          </div>

          <v-spacer> </v-spacer>

          <v-text-field
            class="mr-6"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 450px;"
          ></v-text-field>

          <relacao-entre-filiais-dialog
            :itemParaEdicao="itemSelecionado"
            @salvo-com-sucesso="initialize()"
          ></relacao-entre-filiais-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.filiais_cds="{item}">
        <v-chip
          v-for="filial in item.filiais_cds.split(',')"
          :key="filial"
          small
          class="ml-1"
        >
          {{filial}}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Item" class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon title="Remover Item" @click="deleteItems([item])">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import FilialAPI from "../../api/filial";
import RelacaoEntreFiliaisDialog from "./RelacaoEntreFiliaisDialog.vue"

export default {
  components: {RelacaoEntreFiliaisDialog},
  data: () => ({
    search: "",
    itemsSelecionados: [],
    desserts: [],
    itemSelecionado: {},
    headers: [
      {text: "Id Grupo",value: "id",},
      {text: "Descrição do Grupo",value: "descricao",},
      {text: "Filial",value: "filial",},
      {text: "Filial CD",value: "filiais_cds"},
      {
        text: "",
        value: "action",
        sortable: false,
        width: "100px",
        align: "center",
      },
    ]
  }),
  created() {
    this.initialize();
  },
  methods: {
    abrirDialogMapaCompra() {
      this.dialog = true;
    },
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();
        FilialAPI.getListaMapaCompra(headers)
          .then((response) => {
            const {token, itens} = response.data;
            localStorage.setItem("token", token);
            this.desserts = itens
          })
          .catch(() => {
            this.Helpers.logout();
          })
    },
    editItem(item) {
      const {id, filial, filiais_cds} = item

      this.itemSelecionado = {
        grupos: id,
        filial,
        filial_cd: []
      }

      const filiais = filiais_cds.split(',')

      filiais.forEach(filial => {
        this.itemSelecionado.filial_cd.push(parseInt(filial))
      });
    },
    deleteItems(items) {
      if (confirm("Deseja remover usuário?")) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = this.Helpers.arrayColumn(items, "filial");

        this.$store.dispatch(
          "loading/addRequisicao",
          FilialAPI.deletarMapaCompra(headers, {items: params})
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.initialize();
              this.itemsSelecionados = [];
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  }
}

</script>
